import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash-es';
import { AppState } from '../core.state';
import { UniqueColorPipe } from '../pipes/ucolor.pipe';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'charla-avatar',
    template: `@if ((channel == 1) || (channel == 0)) {
  <div class="avatar" [style.backgroundColor]="color" [style.width]="size" [style.height]="size"  >
    <img [src]="avatar" />
  </div>
}
@if (channel == 2) {
  <div class="messenger" title="Received from Messenger" [style.width]="size" [style.height]="size">
    <img class="instagram-photo" [src]="avatar" />
    <img class="messenger-logo" src="/assets/media/logos/messenger.svg" />
  </div>
}
@if (channel == 3) {
  <div class="messenger" title="Received from Instagram" [style.width]="size" [style.height]="size">
    <img class="messenger-photo" [src]="avatar" />
    <img class="instagram-logo" src="/assets/media/logos/instagram.svg" />
  </div>
}
@if (channel == 4) {
  <div class="messenger" title="Received from WhatsApp" [style.width]="size" [style.height]="size">
    <img class="messenger-photo" [src]="avatar" />
    <img class="whatsapp-logo" src="/assets/media/logos/whatsapp.svg" />
  </div>
}
@if (channel == 5) {
  <div class="messenger" title="Received from Telegram" [style.width]="size" [style.height]="size">
    <img class="messenger-photo" [src]="avatar" />
    <img class="telegram-logo" src="/assets/media/logos/telegram.svg" />
  </div>
}
`,
    styleUrls: ['./avatar.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CharlaAvatarComponent implements OnChanges {

    @Input() visitor_id: string;
    @Input() pic: string;
    @Input() size: string;
    @Input() channel: number = 1;
    color: string;
    avatar: string;
    path_messenger = environment.storageUrl + "messenger-photos";
    path_instagram = environment.storageUrl + "instagram-accounts";
    path_telegram = environment.storageUrl + "telegram-accounts";

    constructor(
        private colorPipe: UniqueColorPipe,
        private store: Store<AppState>
    ){
        this.updateAvatar();
     }

    ngOnChanges(changes: SimpleChanges): void {
        if ( changes['visitor_id'] ) {
            this.updateAvatar();
        }
    }

    updateAvatar(){

        if (!isNil(this.visitor_id)){
            if ( (this.pic) && (this.pic != "00000000-0000-0000-0000-000000000000") ){
                // messenger profile pic
                if (this.channel == 2) {
                    this.avatar =  `${this.path_messenger}/${this.pic}`;
                } else if (this.channel == 3){
                    this.avatar =  `${this.path_instagram}/${this.pic}`;
                } else if (this.channel == 5){
                    this.avatar =  `${this.path_telegram}/${this.pic}`;
                }
            } else {
                // normal avatar
                this.avatar = `/assets/media/avatars/${this.digits(this.visitor_id)}.png`;
                this.color = this.colorPipe.getRandomColor(this.visitor_id);
            }

        }  
  

    }

    digits(guid) {
        
      var digit = guid.replace( /\D/g, '');
      return '' + digit[0] + digit[1];
    }
}